import React, { useEffect } from 'react';

import FrameView from './FrameView';
import WithLoading from '../../Hoc/WithLoading';

const Frame = ({ alias }) => {
  const getFrame = `/final-image/frame/${alias}`;
  useEffect(() => {}, [alias]);
  return (
    <WithLoading
      component={FrameView}
      url={getFrame}
      onlyLoader
      padding="6rem"
    />
  );
};

export default React.memo(Frame);
